import { handleActions, combineActions } from 'redux-actions'

import * as rawActions from '../actions'

const defaultState = null

export default handleActions(
  {
    [rawActions.setSelectedTargetContentForMerging](state, action) {
      return action.payload
    },
    [combineActions(
      rawActions.resetState,
      rawActions.resetShareSessionDialog,
      rawActions.removeOwner,
      rawActions.setTenantForSharing
    )](state, action) {
      return defaultState
    },
  },
  defaultState
)
